import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import { useTranslation } from '../hooks';
import { useFooterHandlers } from './hooks/useFooterHandlers';

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${({ theme }) => theme.spacing.values.half};
`;

export const DATA_TEST = {
  footer: 'catalog-segmentation-footer',
};

export const Footer = () => {
  const { t } = useTranslation();
  const { onPreviewOpen, onApplyQuery } = useFooterHandlers();

  return (
    <FooterWrapper data-test={DATA_TEST.footer}>
      <SecondaryButton onClick={onPreviewOpen}>{t('catalogQuery.footer.preview')}</SecondaryButton>
      <PrimaryButton onClick={onApplyQuery}>{t('catalogQuery.footer.query')}</PrimaryButton>
    </FooterWrapper>
  );
};
